export const SHOW_SETUP_INSTRUCTIONS = "show_setup_instructions";
